import request from '../utils/request.js'

/**
 * 获取可用金额
 * **/
export function getAvailableBalance() {
  return request({
    url: '/rest/recharge/availableBalance',
    method: 'get'
  })
}


/**
 * 获取充值配置
 * **/
export function getRechargeConfig() {
  return request({
    url: '/rest/recharge/rechargeConfig',
    method: 'get'
  })
}


/**
 * 去充值
 * **/
export function saveFun(data) {
  return request({
    url: '/rest/recharge/save',
    method: 'post',
    data:data
  })
}



/**
 * 获取充值记录
 * **/
export function pageRechargeRecords(data) {
  return request({
    url: '/rest/recharge/pageRechargeRecords',
    method: 'get',
    params:data
  })
}



/**
 * 获取消费记录
 * **/
export function pageConsumeRecords(data) {
  return request({
    url: '/rest/recharge/pageConsumeRecords',
    method: 'get',
    params:data
  })
}


/**
 * 提现
 * **/
export function refund(data) {
  return request({
    url: '/rest/recharge/refund',
    method: 'post',
    data:data
  })
}



/**
 * 获取购物金订单详情
 * **/
export function getById(id) {
  return request({
    url: '/rest/recharge/getById?id=' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/shoppingGold.js